import t from "./highrise1428.mjs";
import o from "./highrise509.mjs";
import p from "./highrise1429.mjs";
import e from "./highrise648.mjs";
function n(r, a) {
  var m = e(r) ? t : p;
  return m(r, o(a));
}
export {
  n as default
};
